<template>
  <TransitionRoot appear :show="isOpen" as="template">
    <Dialog as="div" @click="emits('cancel')" class="relative z-50">
      <div class="fixed inset-0 bg-black/30" aria-hidden="true" />

      <TransitionChild
        as="template"
        enter="duration-300 ease-out"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="duration-200 ease-in"
        leave-from="opacity-100"
        leave-to="opacity-0">
        <div class="fixed inset-0 bg-black bg-opacity-25" />
      </TransitionChild>

      <div class="fixed inset-0 overflow-y-auto">
        <div class="flex min-h-full items-center justify-center p-4 text-center">
          <TransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0 scale-95"
            enter-to="opacity-100 scale-100"
            leave="duration-200 ease-in"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-95">
            <DialogPanel class="w-140 relative transform bg-white px-10 py-12 text-left align-middle shadow-xl transition-all">
              <button @click="emits('cancel')">
                <IcClose />
              </button>
              <div class="my-6 max-h-96">
                <slot name="content"></slot>
              </div>
              <div class="flex items-center justify-around">
                <OutlineButton v-if="cancelText" :label="cancelText" @click="emits('cancel')" class="bottom-6 left-16" />
                <FilledButton v-if="confirmationText" :label="confirmationText" @click="emits('add')" class="bottom-6 right-16" />
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>
<script setup lang="ts">
import { IConfirmationModalEmits } from '@/interfaces/components/emits'
import { TransitionRoot, TransitionChild, Dialog, DialogPanel } from '@headlessui/vue'
import IcClose from '@/components/Icons/IcClose.vue'

import FilledButton from '@/components/Globals/Buttons/FilledButton.vue'
import OutlineButton from '@/components/Globals/Buttons/OutlineButton.vue'

defineProps<{
  isOpen: boolean
  cancelText?: string
  confirmationText?: string
}>()

const emits = defineEmits<IConfirmationModalEmits>()
</script>
